
import { defineComponent, computed } from "vue";
import { useStore } from "vuex";
import { isMicrosoft, MicrosoftLogin } from "@/utils/auth";

export default defineComponent({
  name: "HomeView",
  components: {},

  setup() {
    const featureList = [
      {
        title: "BLIP",
        des:
          "Bootstrapping language-image pre-training with frozen image encoders and large language models.",
        img: require("@/assets/Feature_icon_1.png"),
      },
      {
        title: "stable diffusion",
        des:
          "Generating photo-realistic images from text or image input based on latent diffusion model.",
        img: require("@/assets/Feature_icon_2.png"),
      },
      {
        title: "InstructPix2Pix",
        des:
          "Turning simple line drawing into oil paintings based on conditional adversarial network.",
        img: require("@/assets/Feature_icon_3.png"),
      },
      {
        title: "ControlNet",
        des: "Using additional conditions to control pre-trained large diffusion models.",
        img: require("@/assets/Feature_icon_4.png"),
      },
      {
        title: "Grounding DINO",
        des: "Detecting bounding boxes based on text instructions.",
        img: require("@/assets/Feature_icon_5.png"),
      },
      {
        title: "Azure OpenAI",
        des:
          "Providing customers OpenAI models integrated with Microsoft-developed content filtering and abuse detection models.",
        img: require("@/assets/Feature_icon_6.png"),
      },
      {
        title: "Segment Anything",
        des:
          "Producing high quality object masks for all objects in an image from input prompts such as points or boxes.",
        img: require("@/assets/Feature_icon_7.png"),
      },
    ];
    const store = useStore();
    const isMicrosoftEnv: boolean = isMicrosoft();
    const isLogin = computed(() => {
      return store.state.accessToken ? true : false;
    });

    const isChineseIP = computed(() => {
      return store.state.isChineseIP ? true : false;
    });

    return {
      featureList,
      isMicrosoftEnv,
      isLogin,
      isChineseIP,
    };
  },
});
